module.exports = __webpack_public_path__ + "03e460c7242cd6311ffa5967c2e9f558.png";